import { TaggableSendConditionAttribute } from '../types/AutomationSendConditions';

export const taggableSendConditionAttributes: Record<TaggableSendConditionAttribute, true> = {
  AppointmentTypeId: true,
  ClinicRoomId: true,
  ClinicEmployeeId: true,
  SpeciesType: true,
  CareMembershipStatus: true,
};
